import React, { Component } from "react";
import {  Modal } from "react-bootstrap";
import TitleDetailsList from "containers/property/TitleDetailsList";


export default class TitleDetailsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
        };
    }
    
    async componentDidMount() {
        console.log("In TitleDetailsModal componentDidMount");

        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }  
    }

    componentWillUnmount() {
        this.setState({ entities: [] });
    }

    renderTitleDetails() {
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.toggleTitleDetailsModal}
                dialogClassName="modal-90w"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Parcels</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ 'overflowX': 'scroll' }}>
                    <TitleDetailsList
                        filter={this.props.filter}
                        isAuthenticated={this.props.isAuthenticated}
                        isLoading={this.state.isLoading}
                        controlType="table"
                        saveForm={this.props.saveForm}
                        user={this.props.user}
                        data={this.props.data}
                        dataFetch={this.props.dataFetch}
                        updateTableState={this.props.updateTableState}
                        saveRecord={this.props.saveRecord}
                        deleteRecord={this.props.deleteRecord}
                        validateRelatedRecord={this.props.validateRelatedRecord}
                        streetOptions={this.props.streetOptions}
                        context={this.props.context}
                        stateCode={this.props.stateCode}
                    />
                </Modal.Body>
            </Modal>
        );
    }
    
    render() {
        return (
            <div className="TitleDetailsEdit">
                {this.props.isAuthenticated ? this.renderTitleDetails() : console.log("error)")}
            </div>
        );
    }
}
